<template>
  <el-date-picker
    v-model="dateRange"
    type="datetimerange"
    range-separator="to"
    start-placeholder="Start Date"
    end-placeholder="End Date"
  />
</template>
<script>
export default {
  name: "DateTimeRangePicker",
  props: {
    startDate: { type: String, default: "" },
    endDate: { type: String, default: "" },
    timezone: { type: String, default: "+08:00" },
  },
  data() {
    return {
      dateRange: [],
      displayFormat: "yyyy-MM-dd HH:mm",
      valueFormat: "yyyy-MM-ddTHH:mm:ss",
    };
  },
  watch: {
    startDate: {
      immediate: true,
      handler(val) {
        this.updateDateRange();
      },
    },
    endDate: {
      immediate: true,
      handler(val) {
        this.updateDateRange();
      },
    },
  },
  methods: {
    updateDateRange() {
      let start =
        typeof this.startDate === "string" && this.startDate
          ? this.startDate.replace("Z", this.timezone)
          : null;
      let end =
        typeof this.endDate === "string" && this.endDate
          ? this.endDate.replace("Z", this.timezone)
          : null;
      // el-date-picker 必须是数组且元素为 string|null
      if (start !== null && typeof start !== "string") start = null;
      if (end !== null && typeof end !== "string") end = null;
      this.dateRange = [start, end];
      if (!Array.isArray(this.dateRange) || this.dateRange.length !== 2) {
        this.dateRange = [null, null];
      }
    },
    onRangeChange(val) {
      if (Array.isArray(val) && val.length === 2) {
        // 拼接时区，转为 ISO 字符串
        const [start, end] = val;
        if (start) {
          const startStr = start.length > 10 ? start : start + "T00:00:00";
          this.$emit("update:startDate", startStr + this.timezone);
        }
        if (end) {
          const endStr = end.length > 10 ? end : end + "T00:00:00";
          this.$emit("update:endDate", endStr + this.timezone);
        }
      }
    },
  },
};
</script>
